// extracted by mini-css-extract-plugin
export default {"root":"Client_root__G-6a-","client":"Client_client__rJ1XM","avatar":"Client_avatar__nYBk8"};